import { toast } from 'react-toastify';

export const ToastProvider = ({ children }) => children;

export const useToasts = () => {
  const addToast = (message, options = {}) => {
    const appearance = options?.appearance || 'info';
    // Progress toasts pass an `id` so they can be updated in place, and
    // `autoDismiss: false` to stay visible until the work finishes.
    const config = {};
    if (options?.id) config.toastId = options.id;
    if (options?.autoDismiss === false) config.autoClose = false;

    switch (appearance) {
      case 'success':
        return toast.success(message, config);
      case 'error':
        return toast.error(message, config);
      case 'warning':
        return toast.warn(message, config);
      default:
        return toast.info(message, config);
    }
  };

  const updateToast = (id, message, appearance = 'info') => {
    if (!id) return addToast(message, { appearance });
    return toast.update(id, {
      render: message,
      type: appearance,
      isLoading: false,
      autoClose: 4000,
    });
  };

  return {
    addToast,
    updateToast,
    removeAllToasts: () => toast.dismiss(),
  };
};
